export enum PageName {
  LOGIN = 'login',
  OTP_VERIFICATION = 'otp_verification',
  PORTFOLIO = 'portfolio',
  INVEST = 'invest',
  CHECKOUT = 'checkout',
  TRANSACTIONS = 'transactions',
  TRANSACTION_DETAILS = 'transaction_details',
  NOT_FOUND = 'not_found',
}

export enum CtaName {
  SEND_OTP = 'send_otp',
  RESEND_OTP = 'resend_otp',
  TOP_UP = 'top_up',
  ADD_FOLIO = 'add_folio',
  CONFIRM_PAYMENT = 'confirm_payment',
  RETRY_CHECKOUT = 'retry_checkout',
  DISMISS_CHECKOUT = 'dismiss_checkout',
  LOGOUT = 'logout',
}

export enum ControlName {
  PORTFOLIO_VIEW = 'portfolio_view',
  TRANSACTION_STATUS = 'transaction_status',
  TRANSACTION_DATE_RANGE = 'transaction_date_range',
}

export enum AppErrorCode {
  RENDER_ERROR = 'render_error',
  TENANT_UNAVAILABLE = 'tenant_unavailable',
  TENANT_NOT_WHITELABEL = 'tenant_not_whitelabel',
}

export enum CheckoutErrorCode {
  PAYMENT_FAILED = 'payment_failed',
  SDK_IMPORT_FAILED = 'sdk_import_failed',
  SDK_INIT_FAILED = 'sdk_init_failed',
  DEPENDENCIES_FAILED_TO_LOAD = 'dependencies_failed_to_load',
}

export enum SessionErrorCode {
  SESSION_EXPIRED = 'session_expired',
}

export enum CloseTrigger {
  USER_DISMISS = 'user_dismiss',
}

export const HOLDING_VIEWS = ['scheme', 'folio'] as const;

export const TRANSACTION_STATUS_FILTERS = ['all', 'successful', 'pending', 'failed'] as const;

export const TRANSACTION_DATE_RANGES = ['last_7_days', 'last_30_days', 'last_90_days'] as const;

export const CONTROL_VALUES = [...HOLDING_VIEWS, ...TRANSACTION_STATUS_FILTERS, ...TRANSACTION_DATE_RANGES] as const;

export const CHECKOUT_FLOWS = ['onboarding', 'topup', 'add_folio'] as const;

export const CHECKOUT_OUTCOME_EVENTS = ['payment_success', 'bank_transfer_submitted'] as const;

export const ENTRY_ACTIONS = ['login', 'onboard'] as const;

export const ENTRY_ERROR_CODES = [
  'link_missing',
  'link_invalid',
  'portal_not_configured',
  'session_unavailable',
  'checkout_unavailable',
  'signin_unavailable',
  'session_not_established',
  'unexpected',
] as const;

export const API_RESULT_STATUSES = ['succeeded', 'failed'] as const;

export const API_FAILURE_KINDS = ['network', 'schema_validation', 'http', 'unknown'] as const;

export const SCHEME_NO_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const ERROR_CODE_PATTERN = /^[A-Z0-9_]{1,64}$/i;

export const TENANT_DOMAIN_PATTERN = /^[A-Za-z0-9.-]{1,253}$/;
